import errorMap from '@gap/backend/util/validations/validation-error-map'
import { z } from 'zod'
import { CompareSchemas } from '@gap/utils/utils'
import { clientStatuses } from '@gap/backend/app-services/org/advisor/models/ClientEnums'
import { AdvisorClientEntityType } from '@gap/backend/database/entities/advisor/AdvisorClientEntity'
import { advisorClientLinkStatuses } from './AdvisorClientLinkStatusEnum'
import { normalisedEmailValidation } from '@gap/backend/util/validations/validation-email'

const AdvisorClientEntityDtoSchema = z.object({
   id: z.string({ errorMap }),
   advisorOrgId: z.string({ errorMap }),
   clientOrgId: z.string({ errorMap }).optional(),
   xeroId: z.string({ errorMap }).optional(),
   fyiId: z.string({ errorMap }).optional(),
   status: z.enum(clientStatuses),
   linkStatus: z.enum(advisorClientLinkStatuses),
   name: z.string({ errorMap }).min(1),
   primaryContactFirstName: z.string({ errorMap }).min(1),
   primaryContactLastName: z.string({ errorMap }).min(1),
   primaryContactFullName: z.string({ errorMap }),
   email: normalisedEmailValidation,
   primaryContactPhoneNumber: z.string({ errorMap }).optional(),
   accessUserIds: z.array(z.string()).optional(),
   isDemo: z.boolean().optional(),
   lastUpdatedAt: z.string({ errorMap }),
   lastUpdatedBy: z.string({ errorMap }),
})

// Ensure schema is equal to entity. Note, electrodb's EntityItem doesnt have support for optional types, but atleast we can check for variables
0 as CompareSchemas<z.output<typeof AdvisorClientEntityDtoSchema>, AdvisorClientEntityType>

export default AdvisorClientEntityDtoSchema
